import { Injectable } from '@angular/core';
import {AngularFireMessaging} from '@angular/fire/messaging';
import {AppConfig} from '../app.config';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  public notificationUrl = this.config.baseUrl + 'api/notification/';
  public firebaseTokenUrL = this.config.baseUrl + 'api/device_token/';
  constructor(private angularFireMessaging: AngularFireMessaging,
              private config: AppConfig,
              private http: HttpClient) { }
  requestPermission(): any{
    this.angularFireMessaging.requestToken.subscribe(
      (notificationToken) => {
        localStorage.setItem('device_token', notificationToken);
        },
      (err) => {console.log(err); }
    );
  }
  sendNotification(notification): any{
    return this.http.post(this.notificationUrl, notification, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    }).pipe(map( (response: Response) => {
      return response;
    }));
  }
  deleteToken(id): any{
    return this.http.delete(this.notificationUrl + id, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    }).pipe(map( (response: Response) => {
      return response;
    }));
  }
  detailOfFirebaseToken(id): any{
    return this.http.get(this.firebaseTokenUrL + id, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    }).pipe(map( (response: Response) => {
      return response;
    }));
  }
  listOfFirebaseTokens(): any{
    return this.http.get(this.firebaseTokenUrL, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    }).pipe(map( (response: Response) => {
      return response;
    }));
  }
  // tslint:disable-next-line:variable-name
  storeFirebaseToken(device_token): any{
    return this.http.post(this.firebaseTokenUrL, device_token, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    }).pipe(map( (response: Response) => {
      return response;
    }));
  }
}
